import { ref } from 'vue';
import { defineStore } from 'pinia';
import { getApprovalQueue, type ApprovalQueueItem } from '@/api/order-forms';

export const useApprovalsStore = defineStore('approvals', () => {
  const items = ref<ApprovalQueueItem[]>([]);

  const refresh = async () => {
    items.value = await getApprovalQueue();
  };

  return { items, refresh };
});
